import authGraphQLRequest from "utils/authGraphQLRequest";
import moment from "moment";

let prevSearchText = "";

const snakeToCamel = (str: string) =>
    str.replace(/_([a-z])/g, (g) => g[1].toUpperCase());

const toGraphQLInput = (obj: any): string => {
    if (typeof obj !== 'object' || obj === null) return JSON.stringify(obj);
    const entries = Object.entries(obj).map(([key, value]) => {
        const camelKey = snakeToCamel(key);
        if (typeof value === 'object' && value !== null) {
            return `${camelKey}: ${toGraphQLInput(value)}`;
        }
        if (typeof value === 'boolean' || typeof value === 'number') {
            return `${camelKey}: ${value}`;
        }
        return `${camelKey}: "${value}"`;
    });

    return `{ ${entries.join(' ')} }`;
};
 
export const getKycVelocity = ({ page, per_page, searchTexts}: any): Promise<any> => {

    let currentPage = page;

    if (searchTexts && !prevSearchText) {
      currentPage = 1; 
    }

    prevSearchText = searchTexts || "";

    return new Promise((resolve, reject) => {

        let queryString = `{ 
        listKycVelocities(
            page: ${currentPage}, 
            perPage: ${per_page}, 
            searchText: "${searchTexts}"
        ) {
            kycVelocities {
                id
                velocityId
                country
                transactionLimit
                noKyc
                sdd
                edd
                maxTransactionAmount
                paymentMethods
                createdAt
                updatedAt
            }
            totalCount
            currentPage
            totalPages
        }
        }`;
    
        authGraphQLRequest<any>(
        queryString,
        '/api/v1/graphql_kyc_velocity_list'
        )
        .then((responseData) => {
            resolve(responseData);
        })
        .catch((err) => {
            reject(err);
        });
    });
};

export const getKycDetails = (id: any): Promise<any> => {
    return new Promise((resolve, reject) => {

        let queryString = `query {
            getKycVelocity(velocityId: "${id}") {
                id
                velocityId
                country
                transactionLimit
                noKyc
                sdd
                edd
                maxTransactionAmount
                paymentMethods
                createdAt
                updatedAt
            }
        }`;
    
        authGraphQLRequest<any>(
        queryString,
        '/api/v1/graphql_kyc_velocity_get'
        )
        .then((responseData) => {
            resolve(responseData);
        })
        .catch((err) => {
            reject(err);
        });
    });
};

export const createKycVelocity = (data: any): Promise<any> => {
    return new Promise((resolve, reject) => {

        let queryString = `mutation {
            createKycVelocity(
                country: "${data.country}"
                transactionLimit: ${toGraphQLInput(data.transaction_limit)}
                noKyc: ${toGraphQLInput(data.no_kyc)}
                sdd: ${toGraphQLInput(data.sdd)}
                edd: ${toGraphQLInput(data.edd)}
                maxTransactionAmount: ${toGraphQLInput(data.max_transaction_amount)}
                paymentMethods: ${toGraphQLInput(data.payment_methods)}
            ) {
                status
                message
                kycVelocity
            }
        }`;

    
        authGraphQLRequest<any>(
        queryString,
        '/api/v1/graphql_kyc_velocity_create'
        )
        .then((responseData) => {
            resolve(responseData);
        })
        .catch((err) => {
            reject(err);
        });
    });
}

export const updateKycVelocity = (data: any,id:any): Promise<any> => {
    return new Promise((resolve, reject) => {

        let queryString = `mutation {
            updateKycVelocity(
                velocityId: "${id}"
                country: "${data.country}"
                transactionLimit: ${toGraphQLInput(data.transaction_limit)}
                noKyc: ${toGraphQLInput(data.no_kyc)}
                sdd: ${toGraphQLInput(data.sdd)}
                edd: ${toGraphQLInput(data.edd)}
                maxTransactionAmount: ${toGraphQLInput(data.max_transaction_amount)}
                paymentMethods: ${toGraphQLInput(data.payment_methods)}
            ) {
                status
                message
                kycVelocity
            }
        }`;

    
        authGraphQLRequest<any>(
        queryString,
        '/api/v1/graphql_kyc_velocity_update'
        )
        .then((responseData) => {
            resolve(responseData);
        })
        .catch((err) => {
            reject(err);
        });
    });
}

export const deleteKycVelocity = (id:any): Promise<any> => {
    return new Promise((resolve, reject) => {

        let queryString = `mutation 
            {
                deleteKycVelocity(velocityId: "${id}") {
                    status
                    message
                    error
                }
            }   `;

    
        authGraphQLRequest<any>(
        queryString,
        '/api/v1/graphql_kyc_velocity_delete'
        )
        .then((responseData) => {
            resolve(responseData);
        })
        .catch((err) => {
            reject(err);
        });
    });
}